function formatTime(value) {
  const match = String(value || '').match(/^(\d{1,2}):(\d{2})/);
  if (!match) return 'Time not set';
  const hour = Number(match[1]);
  return `${hour % 12 || 12}:${match[2]} ${hour >= 12 ? 'PM' : 'AM'}`;
}

function formatDate(value) {
  const date = new Date(`${value}T12:00:00Z`);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC' });
}

function formatCountdown(minutes) {
  if (minutes <= 0) return 'Now';
  if (minutes < 60) return `in ${minutes} min`;
  if (minutes < 1440) {
    const hours = Math.floor(minutes / 60);
    const remainder = minutes % 60;
    return `in ${hours}h${remainder ? ` ${remainder}m` : ''}`;
  }
  const days = Math.floor(minutes / 1440);
  return `in ${days} day${days === 1 ? '' : 's'}`;
}

export default function UpcomingCarpoolsPanel({ runs, loading, error, schoolCount, navigate }) {
  const nextRun = runs[0] || null;

  return (
    <section className="sa-upcoming-carpools" aria-labelledby="upcoming-carpools-title">
      <div className="sa-upcoming-carpools-head">
        <div>
          <div className="sa-upcoming-carpools-eyebrow">Across all schools</div>
          <h3 id="upcoming-carpools-title">Upcoming Carpools</h3>
          <p>Each school&apos;s next scheduled carpool day within the coming week{schoolCount ? ` · ${schoolCount} schools checked` : ''}.</p>
        </div>
        {nextRun ? (
          <div className="sa-next-carpool-summary">
            <span>Next up</span>
            <strong>{nextRun.school_name} · {formatTime(nextRun.dismissal_time)}</strong>
            <small>{nextRun.carpool_name} · {formatCountdown(nextRun.minutes_until)}</small>
          </div>
        ) : null}
      </div>

      {loading ? <div className="sa-upcoming-carpools-state">Loading upcoming carpools…</div> : null}
      {!loading && error ? <div className="sa-error">{error}</div> : null}
      {!loading && !error && runs.length === 0 ? (
        <div className="sa-upcoming-carpools-state">No scheduled carpools in the next 7 days.</div>
      ) : null}
      {!loading && !error && runs.length > 0 ? (
        <div className="sa-upcoming-carpools-list">
          {runs.map((run, index) => (
            <button
              type="button"
              className={`sa-upcoming-carpool-row ${index === 0 ? 'is-next' : ''}`}
              key={`${run.school_id}-${run.date}-${run.carpool_line_id}`}
              onClick={() => navigate('carpool-schedule', run.school_id)}
            >
              <span className="sa-upcoming-carpool-when">
                <strong>{formatTime(run.dismissal_time)}</strong>
                <small>{formatDate(run.date)}</small>
              </span>
              <span className="sa-upcoming-carpool-school">
                <strong>{run.school_name}</strong>
                <small>{run.carpool_name}</small>
              </span>
              <span className="sa-upcoming-carpool-countdown">
                {index === 0 ? <b>Next</b> : null}
                {formatCountdown(run.minutes_until)}
              </span>
              <span className="sa-upcoming-carpool-arrow" aria-hidden="true">→</span>
            </button>
          ))}
        </div>
      ) : null}
    </section>
  );
}

export { formatCountdown, formatDate, formatTime };
